import React from 'react';
import { GlassCard } from './GlassCard';

export interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
  height?: string | number;
  subtitle?: string;
}

export const ChartCard: React.FC<ChartCardProps> = ({
  title,
  children,
  className = '',
  action,
  height = '300px',
  subtitle,
}) => {
  const headerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 'var(--space-4)',
  };

  const titleContainerStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-1)',
  };

  const titleStyles: React.CSSProperties = {
    fontSize: 'var(--text-base)',
    fontWeight: 'var(--font-semibold)',
    color: 'var(--text)',
    margin: 0,
  };

  const subtitleStyles: React.CSSProperties = {
    fontSize: 'var(--text-sm)',
    color: 'var(--text-secondary)',
    margin: 0,
  };

  const contentStyles: React.CSSProperties = {
    height: typeof height === 'number' ? `${height}px` : height,
    width: '100%',
    position: 'relative',
  };

  return (
    <GlassCard variant="default" padding="md" className={className}>
      <div style={headerStyles}>
        <div style={titleContainerStyles}>
          <h3 style={titleStyles}>{title}</h3>
          {subtitle && <p style={subtitleStyles}>{subtitle}</p>}
        </div>
        {action && <div>{action}</div>}
      </div>
      <div style={contentStyles}>{children}</div>
    </GlassCard>
  );
};

export default ChartCard;
